import { render, staticRenderFns } from "./SetupOverviewCamera.vue?vue&type=template&id=6fe6fda0&scoped=true"
import script from "./SetupOverviewCamera.vue?vue&type=script&lang=ts"
export * from "./SetupOverviewCamera.vue?vue&type=script&lang=ts"
import style0 from "./SetupOverviewCamera.vue?vue&type=style&index=0&id=6fe6fda0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe6fda0",
  null
  
)

export default component.exports